import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Select from 'react-select';

import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useNavigate } from 'react-router-dom';
import { getApiBaseUrl, getDriverApiBaseUrl } from '../../utils/utils'; 
export default function AttendanceConfigDriver() {

  const API_URL = getDriverApiBaseUrl(); // Use Driver API for attendance configs
  const [msg, setMsg] = useState('')
  const [errormsg, setError] = useState('')



  pdfMake.vfs = pdfFonts.vfs;


  const [data, setData] = useState(null);

  useEffect(() => {
    getDetails()
  }, [])


  
  


   const [partners, setPartners] = useState([]);
    useEffect(() => {
        const fetchPartners = async () => {

            const baseApiUrl = getApiBaseUrl();
            try {
                const response = await axios.get(`${baseApiUrl}/v1.0/partner/retrieve_list?page=0`);
                setPartners(
                    (response.data.data || [])
                );

            } catch (err) {
                setError(err.message || 'Error fetching data');
            } finally {
                // setLoading(false);
            }
        };

        fetchPartners();
    }, []);

console.log('partners:',partners)
  



useEffect(() => {
  if (partners && partners.length > 0) {
    getDetails();
  }
}, [partners]);


 async function getDetails() {
  try {
    const driverApiUrl = getDriverApiBaseUrl();
    const url = `${driverApiUrl}/shypvdriverapp/attendance-config/all?page=0&size=20`;
    const response = await axios.get(url);

    if (response.data.success) {
      const content = response.data.data.content;

      // Use driverId + partnerId as the unique key
      const grouped = new Map();

      content.forEach((item) => {
        const driverId = item.driver?.id || "unknown_driver";
        const partnerId = item.partnerId || "unknown_partner";
        const key = `${driverId}_${partnerId}`; // unique combo

        if (!grouped.has(key)) {
          grouped.set(key, {
            driverId: driverId,
            driverName: item.driver?.name || "N/A",
            driverMobile: item.driver?.mobileNumber || "-",
            partnerId: partnerId,
            requireAttendance: item.requireAttendance,
            allowLogoutAnywhere: item.allowLogoutAnywhere,
            enableGeoRestriction: item.enableGeoRestriction,
            checkinWarehouses: item.checkinWarehouses.map((w) => w.name),
            checkoutWarehouses: item.checkoutWarehouses.map((w) => w.name),
          });
        } else {
          // Merge checkin/checkout warehouses if needed
          const existing = grouped.get(key);
          const newCheckins = item.checkinWarehouses.map((w) => w.name);
          const newCheckouts = item.checkoutWarehouses.map((w) => w.name);

          existing.checkinWarehouses = Array.from(
            new Set([...existing.checkinWarehouses, ...newCheckins])
          );
          existing.checkoutWarehouses = Array.from(
            new Set([...existing.checkoutWarehouses, ...newCheckouts])
          );
        }
      });

      // ✅ Convert partner IDs to partner names before saving
      const formattedData = Array.from(grouped.values()).map((g) => {
        const partnerName = partners?.length
          ? partners.find((p) => p.pid == g.partnerId)?.pname || g.partnerId
          : g.partnerId;

        return {
          driverId: g.driverId,
          driverName: g.driverName,
          driverMobile: g.driverMobile,
          partnerId: g.partnerId,
          partners: partnerName,
          requireAttendance: g.requireAttendance,
          allowLogoutAnywhere: g.allowLogoutAnywhere,
          enableGeoRestriction: g.enableGeoRestriction,
          checkinWarehouses: g.checkinWarehouses.join(", "),
          checkoutWarehouses: g.checkoutWarehouses.join(", "),
        };
      });

      console.log("Driver–Partner rows:", formattedData);
      setData(formattedData);
    }
  } catch (error) {
    console.error("Error fetching attendance data:", error);
  }
}




 const columns = [
  {
    name: 'ID',
    selector: (row, index) => index + 1, // Auto-increment ID
    sortable: false, // Usually no need to sort by index
    width: '70px', // Optional: set a fixed width
  },
  {
    name: 'Driver Name',
    selector: row => row.driverName,
    sortable: true,
  },
  {
    name: 'Driver Mobile',
    selector: row => row.driverMobile,
    sortable: true,
  },
  {
  name: 'Partner(s)',
  selector: row => row.partners,
  sortable: true,
  cell: (row) => (
    <div style={{
      width: '400px',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      textAlign: 'left'
    }}>
      {row.partners}
    </div>
  ),
},

  {
    name: ' Warehouses',
    selector: row => row.checkinWarehouses,
    cell: (row) => (
      <div style={{ width: '300px', wordWrap: 'break-word', whiteSpace: 'normal', textAlign: 'left' }}>
        {row.checkinWarehouses}
      </div>
    ),
    wrap: true,
  },
  {
    name: 'Require Attendance',
    selector: row => row.requireAttendance ? 'Yes' : 'No',
    sortable: true,
    width: '120px'
  },
  
  {
    name: 'Actions',
    cell: (row) => (<>
     {/* <button
        onClick={() => handleEdit(row.driverId,row.partnerId)}
        style={{
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          padding: '6px 12px',
          cursor: 'pointer',
          marginRight:'4px'
        }}
      >
        Edit
      </button> */}

     <button
        onClick={() => handleDelete(row)}
        style={{
          backgroundColor: '#ff5100ff',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          padding: '6px 12px',
          cursor: 'pointer'
        }}
      >
        Delete
      </button>
    </>
     
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
     minWidth: '220px',
  }
];



 const tableData = {
    columns,
    data,
  };


  
  const navigate = useNavigate();
  
      const handleEdit = (driverId,partnerId) => {
    console.log('Editing driver:', driverId, partnerId);
    // Example: navigate to an edit form or open a modal
    //  navigate(`/orders/attendance-setting/driver/${driverId}/editattendance`);
     navigate('/orders/attendance-setting/editattendance', {
  state: {
    driverId: driverId,
    partnerId: partnerId
  },
});
    // or openEditModal(partnerId);
  };

const handleDelete = async (data) =>
  {
    console.log('data is:', data)
  const API_PATH = `${API_URL}shypvdriverapp/attendance-config`;

    try {
        const payload = {
            
            
            driverIds:  [Number(data.driverId)], // convert all IDs to numbers
            partnerId: Number(data.partnerId), // assuming user id is partnerId
            "isActive":false
        };
console.log('payload is ',payload)
        const res = await axios.post(API_PATH, payload, {
            headers: { 'Content-Type': 'application/json' },
        });

        if (res.data.success) {
            console.log('Attendance settings saved successfully:', res.data);
            getDetails()
        } else {
            console.log('Failed to save settings:', res.data.message);
            setError('Failed to save settings:', res.data.message)
        }
    } catch (err) {
        console.error('Error saving attendance settings:', err);
    }
    
  }


  return (
    <div>

      <div className="form-container">
        <div className="row">
          <div className="col-md-6">
            <h5 style={{ float: 'left' }}>Attendance Driver Settings </h5>
          </div>

        </div>



        <div className="row">
          <div className="col-md-11">
            {data && data.length > 0 ? (
              <>
              

                <DataTableExtensions {...tableData}>
        <DataTable
          noHeader
          defaultSortField="partnerId"
          pagination
          highlightOnHover
          striped
          responsive
        />
      </DataTableExtensions>

                

              </>

            ) : ''}
          </div>
        </div>






      </div>
    </div>
  )
}
